import { useCallback } from 'react';
import { getDeviceInformation } from '@kidslabs/module-core';
import type { ResultData } from '../types';
import { authStore$ } from '../stores/auth.store';
import { ErrorCodesEnum } from '../enums';
import { signIn } from 'next-auth/react';
import { useTranslation } from 'next-i18next';

export const useLoginWithPhoneAndOtp = () => {
    const { t } = useTranslation('auth');

    return useCallback(
        async (otp: string) => {
            const deviceInfo = getDeviceInformation();
            return new Promise<ResultData>((resolve, reject) => {
                signIn('otp', {
                    phone_number: authStore$.initValidatePhoneData.get()?.phoneNumber ?? '',
                    secret: authStore$.confirmRequestedValidationPhone.secret.get() ?? 'NO_SECRET',
                    otp: otp,
                    redirect: false,
                    sign: '',
                    device: JSON.stringify(deviceInfo),
                })
                    .then(async response => {
                        if (response?.status === 200) {
                            //: handle after
                            resolve({
                                message: t('text_auth_login_success'),
                                errorCode: ErrorCodesEnum.SUCCESS,
                            });
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        [t]
    );
};
